import Promise from 'bluebird';
import moment from 'moment';

// Configure bluebird to support cancelling
Promise.config({cancellation: true});
window.addEventListener('unhandledrejection', function(e) {
    e.preventDefault();
    throw e.detail.reason;
});


export class APIError extends Error {
    constructor(message, xhr) {
        super();
        this.message = message;
        this.name = this.constructor.name;
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, this.name);
        }
        else {
            this.stack = (new Error()).stack;
        }
        this.xhr = xhr;
    }
}

export function jsonReviver(k, v) {
    if (v instanceof Object && '$ts' in v) {
        return moment(v.$ts * 1000);
    }
    return v;
}

function bindPromise(xhr, opt, resolve, reject, onCancel) {
    opt = {
        rawResponse: false,
        headers: {},
        ...opt
    };

    for (let k of Object.keys(opt.headers)) {
        xhr.setRequestHeader(k, opt.headers[k]);
    }

    xhr.addEventListener("load", e => {
        if (xhr.status < 200 || xhr.status >= 300) {
            return reject(new APIError("Got non-success error code: " + xhr.status, xhr));
        }
        if (opt.rawResponse) {
            resolve(xhr);
        }
        else {
            let content = xhr.responseText;
            if (xhr.getResponseHeader('Content-Type').match(/^application\/json\b/)) {
                content = JSON.parse(content, jsonReviver);
            }
            resolve(content);
        }
    });
    xhr.addEventListener("error", e => {
        reject(new APIError("" + e, xhr));
    });
    onCancel(() => {
        xhr.abort();
    });
}

export function get(path, opt) {
    return new Promise((resolve, reject, onCancel) => {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', path, true);
        bindPromise(xhr, opt, resolve, reject, onCancel);
        xhr.send();
    });
}

export function post(path, data, opt) {
    return new Promise((resolve, reject, onCancel) => {
        const xhr = new XMLHttpRequest();
        xhr.open('POST', path, true);
        xhr.setRequestHeader('X-CSRFToken', document.querySelector('html').dataset.csrfToken);

        bindPromise(xhr, opt, resolve, reject, onCancel);

        if (data instanceof FormData) {
            xhr.send(data);
        }
        else {
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.send(JSON.stringify(data));
        }
    });
}



/** WEBPACK FOOTER **
 ** ./src/xhr.js
 **/